import { Component, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PatientService } from 'src/app/services/patient/patient.service';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';
import moment from 'moment';
import { Document } from 'src/app/utils/interfaces/new/mss-document';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { DisplayDocumentComponent } from 'src/app/fragments/display-document/display-document.component';
import { ProgressFragment } from 'src/app/fragments/modal/progress/progress.fragment';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { FormControl, FormGroup } from '@angular/forms';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { FiltrePatient } from 'src/app/utils/interfaces/new/filtre-patient.interface';
import { CreatePatientFromCdaComponent } from 'src/app/fragments/modal/create-patient-from-cda/create-patient-from-cda.component';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { ComparePatientInfosComponent } from 'src/app/fragments/modal/compare-patient-infos/compare-patient-infos.component';
import { ApercuCrbioComponent } from 'src/app/fragments/modal/apercu-crbio/apercu-crbio.component';
import { JDVValue } from '../inbox/presend-clinicaldocument-modal/presend-clinicaldocument-modal.component';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { DonneesBioValue } from 'src/app/utils/interfaces/new/DonneesBioValue';
import { DonneesBioLigne } from 'src/app/utils/interfaces/new/DonneesBioLigne';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { MessageReleve, PatientInfosStatusValide } from 'src/app/utils/interfaces/new/mss-messagereleve';
import { CertificationService } from 'src/app/services/certification/certification.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { MessageReleveBio } from 'src/app/utils/interfaces/new/MessageReleveBio';
import { FeatureService, FeatureKey } from 'src/app/services/feature/feature.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ActionEnum, DomainEnum, LogFonctionnelService, ResultEnum, TypeTargetEnum } from 'src/app/services/log-fonctionnel/log-fonctionnel.service';
import { MssTypeService } from 'src/app/services/mss/mss-service.factory';


interface MessageReleveForm extends MessageReleve {
  traiter: boolean;
  supprimer: boolean;
  createConsult: boolean;
  patient?: InfosPatient;
  patientIdentiteValidee?: InfosPatient;
  patientIdentiteRecuperee?: InfosPatient;
  patientIdentiteProvisoire?: InfosPatient;
  qualifierIdentity?: boolean;
  isDomaineConfiance?: boolean;
  manuallyAdded?: boolean;
  isLoading?: boolean;
  typeConsult?:string;
  cleanSubject?: string;
}
@Component({
  selector: 'app-courriers-releves',
  templateUrl: './courriers-releves.component.html',
  styleUrls: ['./courriers-releves.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*', marginBottom: '10px'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CourriersRelevesComponent implements OnInit, OnDestroy {
  // public ELEMENT_DATA: Message[] = [
  //   {id: '1', from: 'Hydrogen', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '2', from: 'Helium', to: 'Medecin Précigout', receivedDate: new Date(),  traiter: false, createConsult: false},
  //   {id: '3', from: 'Lithium', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '4', from: 'Beryllium', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '5', from: 'Boron', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '6', from: 'Carbon', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '7', from: 'Nitrogen', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '8', from: 'Oxygen', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '9', from: 'Fluorine', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  //   {id: '10', from: 'Neon', to: 'Medecin Précigout', receivedDate: new Date(), traiter: false, createConsult: false},
  // ];

  displayedColumns: string[] = ['patient-status', 'ins-status', 'from','subject', 'to', 'documentType', 'receivedDate', 'patient', 'typeConsult', 'qualifier', 'traiter', 'supprimer', 'details', 'cr-bio', 'is-read'];
  dataSource: MatTableDataSource<MessageReleveForm>;
  data: Array<MessageReleveForm>;
  dataLength = 0;
  expandedMessage: MessageReleveForm | null=null;
  errorTraitement: Map<MessageReleveForm, Error> = new Map();
  filtersOptions: string;
  public formFilter: FormGroup;

  public typeDocuments: Array<JDVValue> = [];
  public typeDocumentsTableName = 'RefTypeCodeDMP';
  public refTypeConsultation: Referentiel[];
  private typeConsultationDefaut : string ='';

  public validationInsi: Array<JDVValue> = [
    { id: '1', libelle: 'Valide' },
    { id: '0', libelle: 'Non valide' },
  ];

  public listCorrespondants: Correspondant[] = [];
  public Certification_Mode : Boolean;
  constructor(
    private _send: HeaderCommunicationService,
    private _modalService: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _patientSrv: PatientService,
    private _mssSrv: MssServiceFactory,
    private _displayDocumentSrv: DisplayDocumentService,
    private _insSrv: InsRealservice,
    private _snakeBarSrv: SnackbarService,
    private _refSrv: ReferentielService,
    private _correspondantSrv: CorrespondantService,
    public _certificationService: CertificationService,
    private _resourceSrv: RessourceService,
    private _featureSrv: FeatureService,
    private _loginSrv: LoginService,
    private _logSrv: LogFonctionnelService,
  ) {
    const head: Header = {
      isBack: true,
      title: 'Messagerie Sécurisé de Santé',
      backPage: 'messagerie'
    };
    this._send.announceHeader(head);
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public paginatorLength = 0;

  ngOnDestroy(): void { }
  isTooltipVisible = false;

  showTooltip() {
    this.isTooltipVisible = true;
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }
  async ngOnInit(): Promise<void> {
    const loadingModal = this._modalService.openLoading(this._viewContainerRef);
    this.formFilter = new FormGroup({
      patient: new FormControl(),
      document: new FormControl(),
      date: new FormControl(),
      typeDocument: new FormControl(),
      validationInsi: new FormControl(),
    });
    this.Certification_Mode = this._certificationService.isCertificationMode();

    //Recuparation du type par defaut pour l'integration
    this.refTypeConsultation = await this._refSrv.findRefListTable(ReferentielEnum.typeConsultation);
    if(this.refTypeConsultation){
      let currentProfilStr = localStorage.getItem('currentProfil');
      if (currentProfilStr && currentProfilStr !== '') {
        let currentProfil = JSON.parse(currentProfilStr);
        let params = await this._resourceSrv.getResourceSettings(currentProfil.id, "profil");
        if(params){
          const typeConsult = params.find(item => item.settingKey === 'typeConsultMessagerie');
          if (typeConsult?.settingValue) {
            this.typeConsultationDefaut = typeConsult.settingValue;
          }
        }

      }
      //si pas de pref on mets biologie par defaut si existe sinon laisser vide
      if (this.typeConsultationDefaut == '') {
        const typeConsult = this.refTypeConsultation.find(item => item.libelle === 'Biologie');
            if(typeConsult.id){
              this.typeConsultationDefaut = typeConsult.id;
            }
      }
    }

    this._initPaginator();
    await this._initSearchFilters();
    await this._retrieveCorrespondants();
    await this.retrieveCourrierAndUpdateTable();

    this._modalService.close(loadingModal);
  }

  private _initPaginator(): void {
    setTimeout(() => {
      this.paginator.page.subscribe(async (page: PageEvent) => {
        console.log(page);
        await this.retrieveCourrierAndUpdateTable();
      });
    }, 0);
  }

  private async _initSearchFilters(): Promise<void> {
    this.typeDocuments = [];

    const temp = await this._refSrv.findRefListTableHypermed(this.typeDocumentsTableName);
    for (const value of temp) {
      this.typeDocuments.push({
        id: value.id.indexOf('++') > -1 ? value.id.split('++')[0] : value.id,
        libelle: value.libelle
      });
    }
  }

  private async _retrieveCorrespondants(): Promise<void> {
    this.listCorrespondants = await this._correspondantSrv.find();
  }

  async retrieveCourrierAndUpdateTable(): Promise<void> {
    const messagesReleves = await this._mssSrv.getService().getCourrierReleve({
      currentPage: this.paginator && this.paginator.pageIndex ? this.paginator.pageIndex + 1 : 1,
      perpage: this.paginator && this.paginator.pageSize ? this.paginator.pageSize : 10,
      find: this.filtersOptions
    });

    const messages = await Promise.all(messagesReleves.objects.map(async (message): Promise<MessageReleveForm> => {
      const transformedMessage = await this._messageReleveToMessageReleveForm(message);

      // Ajoutez la valeur par défaut ici
      if (!transformedMessage.typeConsult) {
        transformedMessage.typeConsult = this.typeConsultationDefaut? this.typeConsultationDefaut:''; // Définir une valeur par défaut
      }
      transformedMessage.createConsult = true; //par défaut on creer toujours suite ajout type consult

      return transformedMessage;
        // return await this._messageReleveToMessageReleveForm(message);
      })
    );
    setTimeout(() => {
      this.data = messages;
      this.sort.direction = 'desc';
      this.sort.active = 'receivedDate';
      this.sort.start = this.sort.direction;
      this.onMatSortChange(this.sort);

      this.paginatorLength = messagesReleves.total;
    });
  }

  private async _messageReleveToMessageReleveForm(message: MessageReleve): Promise<MessageReleveForm> {

    const _getNumberValue = (v: string | number): number => {
      let nb = typeof v === 'number' ? v : undefined;
      if (typeof v === 'string') {
        nb = Number(v.replace(',', '.'));
      }
      return nb;
    };

    const _getLimit = (v: DonneesBioValue): string => {
      let rtd = '';
      if (
        (v.referenceRange && v.referenceRange.high && v.value && _getNumberValue(v.value) > _getNumberValue(v.referenceRange.high))
        || (v.referenceRange && v.referenceRange.high && v.high && _getNumberValue(v.high) > _getNumberValue(v.referenceRange.high))
      ) {
        rtd = `MAX : ${v.referenceRange?.high}`;
      }
      if (
        (v.referenceRange && v.referenceRange.low && v.value && _getNumberValue(v.value) < _getNumberValue(v.referenceRange.low))
        || (v.referenceRange && v.referenceRange.low && v.low && _getNumberValue(v.low) < _getNumberValue(v.referenceRange.low))
      ) {
        rtd = `MIN : ${v.referenceRange?.low}`;
      }
      return rtd;
    };

    const _getHorsLimiteValue = (l: DonneesBioLigne, v: DonneesBioValue): any => {
      const limit = _getLimit(v);
      return {
        ligne: l.displayName,
        value: v.value ? v.value + `${v.unit ? ' ' + v.unit : ''}` : (v.low ? v.low : '') + ((v.low && v.high) ? ' - ' : '') + (v.high ? v.high : ''),
        limite: `(${limit ? limit + ' — ' : ''}${l.interpretationCode.displayName})`
      };
    };

    let patient = null;
    let patientIdentiteRecuperee = null;
    let patientIdentiteValidee = null;
    let patientIdentiteProvisoire = null;
    let patientRetrieved: InfosPatient = null;
    // TODO Optimiser en cas de gros volume de messages
    // Actuellement, on fait une requête par message tout en parrallèle
    if (message.idPatient) {
      patientRetrieved = await this._patientSrv.findOnePatientInfos(message.idPatient);
      patient = patientRetrieved;
    } else if (message.patientInfosStatusValide) {
      patientRetrieved = await this._patientSrv.findOnePatientInfos(message.patientInfosStatusValide.patientId);
      patientIdentiteValidee = patientRetrieved;
    } else if (message.patientInfosStatusRecupere) {
      patientRetrieved = await this._patientSrv.findOnePatientInfos(message.patientInfosStatusRecupere.patientId);
      patientIdentiteRecuperee = patientRetrieved;
    } else if (message.patientInfosStatusProvisoire) {
      patientRetrieved = await this._patientSrv.findOnePatientInfos(message.patientInfosStatusProvisoire.patientId);
      patientIdentiteProvisoire = patientRetrieved;
    }

    if (message.documentCdaVersions && message.documentCdaVersions.length > 0) {
      for (let i = 0; i < message.documentCdaVersions.length; i++) {
        if (message.documentCdaVersions[i].updatedAt) {
          message.documentCdaVersions[i].updatedAt = `Modifié le ${moment(message.documentCdaVersions[i].updatedAt).format('DD/MM/YYYY à HH:mm')}` as any;
        }
        if (message.documentCdaVersions[i].deletedAt) {
          message.documentCdaVersions[i].deletedAt = `Supprimé le ${moment(message.documentCdaVersions[i].deletedAt).format('DD/MM/YYYY à HH:mm')}` as any;
        }
      }
    }

    if (message.isCrBio && !message.from.includes("apicrypt.org")) { //CR BIO MSS
      // Get the infos of the CR
      const cr = await this._mssSrv.getService().getBioMessageReleve(message.id);

      if(cr && cr.donneesBio && cr.donneesBio.categories && cr.donneesBio.categories.length > 0) {
        for (const categorie of cr.donneesBio.categories) {
          for (const ligne of categorie.lignes) {
            for (const value of ligne.values) {
              if (!(message as any).horsLimitesValues) {
                (message as any).horsLimitesValues = [];
              }
              if (!(message as any).horsLimitesCritiquesValues) {
                (message as any).horsLimitesCritiquesValues = [];
              }

              if (ligne.interpretationCode &&
                (ligne.interpretationCode.code === 'A' || ligne.interpretationCode.code === 'H' ||
                  ligne.interpretationCode.code === 'L')) {
                (message as any).horsLimitesValues.push(_getHorsLimiteValue(ligne, value));
              } else if (ligne.interpretationCode &&
                (ligne.interpretationCode.code === 'AA' || ligne.interpretationCode.code === 'HH' ||
                  ligne.interpretationCode.code === 'LL')) {
                (message as any).horsLimitesCritiquesValues.push(_getHorsLimiteValue(ligne, value));
              }
            }
          }
        }
      }
      if ((message as any).horsLimitesValues && (message as any).horsLimitesValues.length > 0) {
        (message as any).hasErrorInCR = true;
      }
      if ((message as any).horsLimitesCritiquesValues && (message as any).horsLimitesCritiquesValues.length > 0) {
        (message as any).hasCritiquesErrorInCR = true;
      }
    }

    // Vérification si on connait le correspondant
    let isDomaineConfiance = false
    if (message.from) {
      // On selection l'adresse mail du correspondant
      const regex = /(?:<)?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:>)?/;
      const match = message.from.match(regex);
      if (match && match.length > 1) {
        let emailToCheck = match[1].toLowerCase(); // Convertir en minuscule pour éviter la sensibilité à la casse

        if (emailToCheck.includes("apicrypt")) {
          emailToCheck = emailToCheck.split("@")[0];
        }

        isDomaineConfiance = this.listCorrespondants.some((correspondant) =>
          (correspondant.email1 && correspondant.email1.toLowerCase() === emailToCheck) ||
          (correspondant.email2 && correspondant.email2.toLowerCase() === emailToCheck) ||
          (correspondant.adresseApiCrypt && correspondant.adresseApiCrypt.toLowerCase().includes(emailToCheck))
        );
      }
    }
    let MessageTraiter = false;
    if(message.patientInfosStatusProvisoire){
      MessageTraiter = true;
    }
    return {
      ...message,
      cleanSubject: message.subject ? message.subject.replace('XDM/1.0/DDM+', '').trim() : message.subject,
      traiter: MessageTraiter,
      supprimer: false,
      //pourquoi creer une consultation uniquement si il y a un document ?
      // createConsult: !message.documents || message.documents.length < 1 ? true : false,
      createConsult: true,
      patient,
      patientIdentiteRecuperee,
      patientIdentiteValidee,
      patientIdentiteProvisoire,
      isDomaineConfiance
    };
  }


  toggleMessage(message: MessageReleveForm) {
    if (this.expandedMessage === message) {
      this.expandedMessage = null; //Collapse le message si il est ouvert
    } else {
      this.getMessageReleveById(message); //Sinon on ouvre le message
    }
  }

  public async getMessageReleveById(message: MessageReleveForm): Promise<void> {

    if (message.id !== this.expandedMessage?.id) {
      if (!this.expandedMessage) {
        this.expandedMessage = { isLoading: true, ...message};
      } else {
        this.expandedMessage = message;
        this.expandedMessage.isLoading = true;
      }
      let typeSelected = message.typeConsult
      const fetchedMessage = await this._mssSrv.getService().getMessageReleveById(message.id);

      if (message.id && !message.isRead) {
        await this._mssSrv.getService().markMessageAsReadHmo(message.id);
        fetchedMessage.isRead = true;

        const providerType = this._mssSrv.typeService;
        const subDomain = providerType === MssTypeService.apicrypt ? 'Lecture message APICRYPT' : 'Lecture message MSS';
        try {
          await this._logSrv.getConfiguration(DomainEnum.Messagerie).addLog({
            action: ActionEnum.Read,
            result: ResultEnum.Success,
            typeTarget: TypeTargetEnum.NONE,
            subDomain,
            details: `Consultation du message relevé (ID: ${message.id})`
          });
        } catch (e) { console.error('Erreur trace lecture courrier relevé', e); }
      }

      const parsed = await this._messageReleveToMessageReleveForm(fetchedMessage);
      message = parsed;
      if(!message.typeConsult){
        message.typeConsult = typeSelected;
      }
      const messages = this.dataSource.data;
      const index = messages.findIndex((m) => m.id === message.id);
      messages[index] = message;
      this.dataSource.data = messages;
      this.expandedMessage.isLoading = false;
    }
    this.expandedMessage = message;
  }


  // public async openDocumentVersion(cdaVersion: CdaVersions): Promise<void> {
  //   if (cdaVersion && cdaVersion.docId && cdaVersion.docId !== '') {
  //     const doc = await this._documentSrv.downloadDocument(cdaVersion.docId);
  //     if (doc) {
  //       doc.payload = doc.payload.split('base64')[1];
  //       console.log(this.dataSource.data[0].documents[0]);
  //       console.log(doc);

  //       await this._displayDocumentSrv.displayDocument(
  //         this._viewContainerRef,
  //         this._displayDocumentSrv.documentToDisplayContentData(
  //           {
  //             contentType: doc.contentType,
  //             fileName: doc.fileName,
  //             id: doc.id
  //           } as any,
  //           doc.patientId
  //         )
  //       );

  //     }
  //   }
  // }

  public async displayCrBio(message: MessageReleve): Promise<void> {
    if (message.isCrBio) {
      // Open loading modal
      const loadingModal = this._modalService.openLoading(this._viewContainerRef);

      // Get the infos of the CR
      let cr;

      try {
        let fetchedMessage:MessageReleve;
        if(message.from.includes('apicrypt.org')){
          fetchedMessage = await this._mssSrv.getService().getMessageReleveById(message.id)
        }
        if (fetchedMessage && fetchedMessage.content && fetchedMessage.content.includes("****LAB****")) { // bio Hprim Apicrypt
          // cr = this.getBioMessageApicryptHprim(fetchedMessage.content);
          this._modalService.openAlert(this._viewContainerRef, 'Disponible Prochainement', 'Affichage structuré des resultats de biologies HPRIM en cours de développement,\n mais l\'intégration en maquette déja disponible.');
        } else { //bio MSS
          cr = await this._mssSrv.getService().getBioMessageReleve(message.id);
        }

      } catch (e) {
        this._snakeBarSrv.openSnackBar('Erreur lors de la récupération du CR de Bio');
      } finally {
        // Close loading modal
        this._modalService.close(loadingModal);
      }
      if (!cr) {
        return;
      } else {
        const modal = this._modalService.openModal(this._viewContainerRef, ApercuCrbioComponent);
        modal.instance.infoReleve = cr;
        modal.instance.messageId = message.id;
        modal.instance.closeEmitter.subscribe(async (res: boolean) => {
          this._modalService.close(modal);
        });
      }
      console.log(cr);

    }
  }
  private  getBioMessageApicryptHprim(ContentMessage : string): MessageReleveBio{
    let cr: MessageReleveBio ;
    if(ContentMessage){
      const lines = ContentMessage.split('\n');
      let IndexOf_FIN = lines.indexOf('****FIN****'); // on a un Hprim sinon break
      if(IndexOf_FIN > -1){
          // on traite le hprim structuré
          let IndexOf_LAB = lines.indexOf('****LAB****'); // on a un Hprim sinon break
          if(IndexOf_LAB > -1){
              for (let i = (IndexOf_LAB+1); i < IndexOf_FIN; i++) {
                  const splitLine = lines[i].split("|").map(part => part.trim());
                  if(splitLine[1]=='RES'){
                    const displayName = splitLine[2];
                    const type = splitLine[4]; // si NM ou N on traite 5 . par , sinon on affiche 5 tel quel
                    const value = splitLine[5];
                    const unite = splitLine[6]?splitLine[6]:undefined;
                    const rangeNinf = splitLine[7]?splitLine[7]:undefined;
                    const rangeNsup = splitLine[8]?splitLine[8]:undefined;
                    const Normalite = splitLine[9]?splitLine[9]:undefined;
                    const Statut = splitLine[10]?splitLine[10]:undefined;
                  }
              }
          }else{
              cr = undefined; // pas de labo hprim structuré on s'arrete sans creer de maquette
          }
      }else{
        cr = undefined; // pas de labo hprim structuré on s'arrete sans creer de maquette
      }
    }
    return cr;
  }

  public onSubmitRecherche() {
    this.formFilter.markAllAsTouched();
    if (this.formFilter.valid) {
      this.filtersOptions = '';

      let patient = this.formFilter.controls.patient.value;
      let document = this.formFilter.controls.document.value;
      const date = this.formFilter.controls.date.value;
      let typeDocument = this.formFilter.controls.typeDocument.value;
      let validationInsi = this.formFilter.controls.validationInsi.value;

      if (patient && (patient as string).trim().length > 0) {
        patient = encodeURI(patient);
        this.filtersOptions += 'patient=' + patient;
      }

      if (document && (document as string).trim().length > 0) {
        document = encodeURI(document);
        if (this.filtersOptions.length > 0) {
          this.filtersOptions += '&';
        }
        this.filtersOptions += 'document=' + document;
      }

      if (date && moment(date).isValid()) {
        if (this.filtersOptions.length > 0) {
          this.filtersOptions += '&';
        }
        this.filtersOptions += 'date=' + moment(date).format("YYYY-MM-DD");
      }

      if (typeDocument && (typeDocument as string).trim().length > 0) {
        typeDocument = encodeURI(typeDocument);
        if (this.filtersOptions.length > 0) {
          this.filtersOptions += '&';
        }
        this.filtersOptions += 'typeDoc=' + typeDocument;
      }

      if (validationInsi && (validationInsi as string).trim().length > 0) {
        validationInsi = encodeURI(validationInsi);
        if (this.filtersOptions.length > 0) {
          this.filtersOptions += '&';
        }
        this.filtersOptions += 'validationInsi=' + validationInsi;
      }

      this.retrieveCourrierAndUpdateTable();
    }
  }
  public async searchPatientApicrypt(message: MessageReleveForm) {
      const filtrePatient: FiltrePatient = {
        nom: message.infoPatientDocument.patientNomNaissance,
        prenom: message.infoPatientDocument.patientPrenomNaissance,
        dateNaissance: message.infoPatientDocument.patientDateNaissance,
        getArchive:false,
      };
      const resultNom = await this._patientSrv.patientsSearchFilters(filtrePatient, { currentPage: 1, perpage: -1 });
      if(resultNom.objects.length == 1){
        return resultNom.objects[0].id;
      }else{
        return '';
      }

  }

  public findPatient(message: MessageReleveForm): void {
    if (message.from && message.from.includes("apicrypt")) {
        // Recherche asynchrone pour obtenir Apicrypt_idPatient
        this.searchPatientApicrypt(message).then(async (Apicrypt_idPatient) => {
            if (Apicrypt_idPatient) {
                // Si un patient Unique est trouvé automatiquement, récupération des informations du patient
                const patient = await this._patientSrv.findOnePatientInfos(Apicrypt_idPatient);
                message.patient = patient;
                message.manuallyAdded = true;
                message.traiter = true;
                message.supprimer = false;
                //TODO mettre a jour le statut patient du message.
            } else {
                // Si aucun patient n'est trouvé automatiquement, ouvrir la modale de recherche manuelle
                this.openManualSearchModal(message);
            }
        }).catch(error => {
            console.error("Erreur lors de la recherche du patient Apicrypt :", error);
            // En cas d'erreur, ouvrir la modale pour permettre la recherche manuelle
            this.openManualSearchModal(message);
        });
    } else {
        // Si message.from ne contient pas "apicrypt", ouvrir la modale directement
        this.openManualSearchModal(message);
    }
}

  // Méthode pour ouvrir la modale de recherche manuelle
  private openManualSearchModal(message: MessageReleveForm): void {
    const modal = this._modalService.openModalSearchPatient(this._viewContainerRef);
    const sub = modal.instance.closeEmitter.subscribe(async (idPatient: string) => {
        if (idPatient) {
            const patient = await this._patientSrv.findOnePatientInfos(idPatient);
            message.patient = patient;
            message.manuallyAdded = true;
            message.traiter = true;
            message.supprimer = false;
        }
        this._modalService.close(modal);
        sub.unsubscribe();
    });
  }

  public deletePatient(message: MessageReleveForm): void {
    message.patient = undefined;
    message.patientIdentiteRecuperee = undefined;
    message.patientInfosStatusRecupere = undefined;
    message.patientIdentiteProvisoire = undefined;
    message.patientInfosStatusProvisoire = undefined;
    message.manuallyAdded = false;
    message.traiter = false;
  }

  public async createPatientFromMessage(message: MessageReleveForm): Promise<void> {
    if (!message.unknownPatientInfos.patientNomNaissance || !message.unknownPatientInfos.patientPrenomNaissance || !message.unknownPatientInfos.patientDateNaissance || !message.unknownPatientInfos.patientSexe || !message.unknownPatientInfos.patientCpNaissance) {
      let contentAlert = "\nInformations patient manquantes dans le message :"
      if(!message.unknownPatientInfos.patientNomNaissance) {
        contentAlert += "\n- Nom de naissance"
        message.unknownPatientInfos.patientNomNaissance = '';
      }
      if(!message.unknownPatientInfos.patientPrenomNaissance) {
        contentAlert += "\n- Prénom de naissance"
        message.unknownPatientInfos.patientPrenomNaissance = '';
      }
      if(!message.unknownPatientInfos.patientDateNaissance) {
        contentAlert += "\n- Date de naissance"
        message.unknownPatientInfos.patientDateNaissance = '01-01-1901';
      }
      if(!message.unknownPatientInfos.patientSexe) {
        contentAlert += "\n- Sexe"
        message.unknownPatientInfos.patientSexe = '';
      }
      if(!message.unknownPatientInfos.patientCpNaissance) {
        contentAlert += "\n- Code postal de naissance"
        message.unknownPatientInfos.patientCpNaissance = '';
      }
      if(contentAlert){
        const modal = this._modalService.openModalConfirmation(
          this._viewContainerRef,
          'Confirmation',
          contentAlert+'\n\n Voulez-vous créer un patient malgré tout ?'
        );

        const res: boolean = await new Promise((resolve) => {
          modal.instance.closeEmitter.subscribe((response: boolean) => {
            resolve(response);
          });
        });

        if (!res) {
          // Logique pour la réponse non
          return;
        }
      }
      // this._modalService.openAlert(this._viewContainerRef, 'Impossible de créer le patient', contentAlert);
      // return;
    }


    const modal = await this._modalService.openModal(this._viewContainerRef, CreatePatientFromCdaComponent);

    modal.instance.initForm({
      nomNaissance: message.unknownPatientInfos.patientNomNaissance,
      prenomNaissance: message.unknownPatientInfos.patientPrenomNaissance,
      dateNaissance: message.unknownPatientInfos.patientDateNaissance,
      sexe: message.unknownPatientInfos.patientSexe,
      cpNaissance: message.unknownPatientInfos.patientCpNaissance,
      // Règle Ségur Vague 2 / RNIV : 
      // Le réseau MSSanté constitue en lui-même l'Espace de Confiance national.
      // On importe toujours l'INS. La récupération silencieuse après création viendra consolider le tout.
      ins: message.unknownPatientInfos.patientIns,
      insKey: message.unknownPatientInfos.patientInsKey,
      oid: message.unknownPatientInfos.patientOid,
      isInsOk: message.unknownPatientInfos.isInsOk,
      isDomaineConfiance: message.isDomaineConfiance,
      prenomsNaissance: '',
    });

    const modalSub = modal.instance.closeEmitter.subscribe(async patientId => {
      modalSub.unsubscribe();
      modal.destroy();
      if (patientId && patientId !== '') {
        this._snakeBarSrv.openSnackBar('Patient créé avec succès');

        const patient = await this._patientSrv.findOnePatientFiche(patientId);
        if (patient) {
          // Cas 3 : Appel silencieux de l'INSi après création
          await this.recoverPatientIdentity(patient, message);

          // update document (pour ajouter l'ID du patient et ainsi permettre le liaison entre le patient et le document)
          await this._mssSrv.getService().updateCourrierReleve({
            messageId: message.id,
            patientDateNaissance: undefined,
            patientIns: undefined,
            patientInsKey: undefined,
            patientNomNaissance: undefined,
            patientOid: undefined,
            patientPrenomNaissance: undefined,
            patientSexe: undefined,
            isInsOk: undefined,
            patientId: patient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf' ?  patient.id : undefined, // TODO Modifier cette condition par une vérification sur patient.isQualifie quand ça sera mis en place
            patientValideId: patient.identiteStatutId === '19c8e607-95b9-474f-a9cf-34bf58930652' ?  patient.id : undefined, // TODO Modifier cette condition par une vérification sur patient.isValide quand ça sera mis en place
            patientRecupereId: patient.identiteStatutId === '8ba51292-17bb-4215-93bc-0ac6217655a1' ?  patient.id : undefined, // TODO Modifier cette condition par une vérification sur patient.isRecupere quand ça sera mis en place
            patientProvisoireId: patient.identiteStatutId === 'a488948a-d415-476b-badc-9410994e7faf' ?  patient.id : undefined, // TODO Modifier cette condition par une vérification sur patient.isProvisoire quand ça sera mis en place
          });
        }

        // refresh le tableau des courriers relevés
        await this.ngOnInit();
      }
    });
  }

  private _getPrenomsPotentiels(firstNames: string): Array<string> | undefined {
    return firstNames ? firstNames.split(',').map(name => name.trim()) : undefined;
  }

  private async compareAndRecover(message: MessageReleveForm): Promise<boolean> {
    const patientLocal = message.patientIdentiteProvisoire || message.patientIdentiteValidee;
    if (!patientLocal) return true;

    // Récupérer le patient complet pour avoir sa date de naissance, etc.
    const fichePatient = await this._patientSrv.findOnePatientFiche(patientLocal.id);
    if (!fichePatient) return true;

    const formatTrait = (label: string, oldVal: any, newVal: any) => {
      const oldStr = (oldVal ? oldVal : 'Non renseigné').toString().trim();
      const newStr = (newVal ? newVal : 'Non renseigné').toString().trim();
      const match = oldStr.toUpperCase() === newStr.toUpperCase();
      const className = match ? 'trait-match' : 'trait-mismatch';
      return `${label}: <span class="${className}">${oldStr}</span> devient <span class="${className}">${newStr}</span>`;
    };

    const resINSi = message.unknownPatientInfos || message.patientInfosStatusProvisoire || message.patientInfosStatusValide || message.patientInfosStatusRecupere;
    let selectedName = resINSi?.patientPrenomNaissance || '';
    const traitsList = [
      formatTrait('Nom de naissance', fichePatient.nomNaissance, resINSi?.patientNomNaissance),
      formatTrait('1er prénom de naissance', fichePatient.prenom, selectedName),
      formatTrait('Sexe', fichePatient.sexe, resINSi?.patientSexe),
      formatTrait('Date de naissance', moment(fichePatient.dateNaissance, 'YYYY-MM-DD').format('DD/MM/YYYY'), resINSi?.patientDateNaissance ? moment(resINSi.patientDateNaissance).format('DD/MM/YYYY') : 'Non renseigné'),
      formatTrait('Code lieu de naissance', fichePatient.cpNaissance, resINSi?.patientCpNaissance),
      formatTrait('Matricule INS', fichePatient.ins, resINSi?.patientIns),
      formatTrait('Clé INS', fichePatient.insKey, resINSi?.patientInsKey),
      formatTrait('OID', fichePatient.oid, resINSi?.patientOid),
    ];

    const tmpDocsIdentiteHaut = await this._refSrv.findRefListTable(ReferentielEnum.identiteDocsHaut);
    const docsIdentiteBas = await this._refSrv.findRefListTable(ReferentielEnum.identiteDocsBas);
    const docsIdentiteList = [].concat(tmpDocsIdentiteHaut, docsIdentiteBas);

    const isAlreadyQualified = fichePatient.identiteStatutLibelle?.toLowerCase() === 'identité validée' || fichePatient.identiteStatutLibelle?.toLowerCase() === 'identité qualifiée';
    let defaultDoc = fichePatient.documentDeValidation;
    if (!isAlreadyQualified && docsIdentiteList) {
      const cniDoc = docsIdentiteList.find(d => d.id === '026a93be-d90f-4212-a1c0-0dab592e3972');
      if (cniDoc) defaultDoc = cniDoc.id;
    }

    const warnModal = this._modalService.openModalInsQualification(
      this._viewContainerRef,
      'Qualification de l\'identité',
      'L\'identité contenue dans ce document correspond à ce patient, mais le statut local est provisoire.\n\nÊtes-vous sûr de vouloir récupérer son identité via le téléservice INSi avec les informations suivantes ?',
      traitsList,
      docsIdentiteList ? docsIdentiteList.map(doc => ({ value: doc.id, label: doc.libelle })) : [],
      defaultDoc,
      isAlreadyQualified
    );

    const userConfirmed = await new Promise<any>(resolve => {
      const sub = warnModal.instance.closeEmitter.subscribe(res => {
        sub.unsubscribe();
        resolve(res);
      });
    });

    warnModal.destroy();

    if (!userConfirmed || !userConfirmed.confirmed) return false;

    // Mise à jour du document de validation du patient si sélectionné
    if (userConfirmed.documentSelected) {
      fichePatient.documentDeValidation = userConfirmed.documentSelected;
    }

    return await this.recoverPatientIdentity(fichePatient, message);
  }

  public async recoverPatientIdentity(fichePatient: any, message: MessageReleveForm): Promise<boolean> {
    const canUseInsiFeature = await this._featureSrv.canUseFeature(FeatureKey.APPELS_AUTO_INSI);
    if (!canUseInsiFeature) {
      return true;
    }

    const resINSi = message.unknownPatientInfos || message.patientInfosStatusProvisoire || message.patientInfosStatusValide || message.patientInfosStatusRecupere;
    if (!resINSi) return true;
    
    const loadingModal = this._modalService.openLoading(this._viewContainerRef);
    
    const searchParams = {
      s_birthName: (resINSi.patientNomNaissance || '').toUpperCase().replace(/,/g, ' ').trim(),
      s_given: (resINSi.patientPrenomNaissance || '').replace(/,/g, ' ').trim(),
      i_sex: resINSi.patientSexe === 'FEMME' ? 2 : (resINSi.patientSexe === 'HOMME' ? 1 : 0),
      s_birthDate: resINSi.patientDateNaissance ? moment(resINSi.patientDateNaissance).format('YYYY-MM-DD') : undefined
    };

    try {
      const nouvelIns = await this._insSrv.getInsFromIdentityInformation(this._viewContainerRef, searchParams);
      if (nouvelIns && nouvelIns.Identity && nouvelIns.Identity.Ins) {
        fichePatient.ins = nouvelIns.Identity.Ins.s_value;
        fichePatient.insKey = nouvelIns.Identity.Ins.s_key;
        fichePatient.oid = nouvelIns.Identity.Ins.s_oid;

        fichePatient.nomNaissance = nouvelIns.Identity.s_birthName;
        fichePatient.prenomsNaissance = nouvelIns.Identity.s_birthGiven;
        const firstNames = this._getPrenomsPotentiels(nouvelIns.Identity.s_birthGiven);
        if (firstNames && firstNames.length > 0) {
            fichePatient.prenom = firstNames[0];
        }

        if (fichePatient.identiteStatutLibelle === 'identité validée' || fichePatient.documentDeValidation) {
          fichePatient.identiteStatutLibelle = 'identité qualifiée';
          fichePatient.identiteStatutId = '95a6081f-5260-44b8-9661-e4795e1cfcaf';
        } else {
          fichePatient.identiteStatutLibelle = 'identité récupérée';
          fichePatient.identiteStatutId = '14b0df14-72cb-4fa7-88ea-d4ebf32b135f';
        }
        const user = this._loginSrv.getCurrentUser();
        if (!fichePatient.historique) fichePatient.historique = [];
        fichePatient.historique.push({
           type: 'modification' as any,
           date: new Date(),
           newIdentite: { statut: fichePatient.identiteStatutLibelle },
           responsable: { id: user ? user.id : 'systeme', libelle: user ? (user.nom + ' ' + user.prenom) : 'Système (Récupération auto INSi MSS)' }
        });
        
        fichePatient.lastInsCheckDate = new Date();
        await this._patientSrv.updatePatientFiche(fichePatient.id || fichePatient.patientId, fichePatient);

        // Mettre à jour l'objet message pour qu'il soit vu comme patient récupéré
        message.patientIdentiteRecuperee = {
          id: fichePatient.id || fichePatient.patientId,
          nom: fichePatient.nomNaissance,
          nomNaissance: fichePatient.nomNaissance,
          prenom: fichePatient.prenom,
          dateNaissance: moment(fichePatient.dateNaissance).format('YYYY-MM-DD')
        };
        message.patientIdentiteProvisoire = undefined;
        message.patientIdentiteValidee = undefined;
        message.patient = undefined;
        
        this._modalService.close(loadingModal);
        this._snakeBarSrv.openSnackBar('Identité INSi récupérée avec succès.');
        return true;
      }
      this._modalService.close(loadingModal);
    } catch (e) {
      console.error("Erreur lors de la récupération INSi: ", e);
      this._modalService.close(loadingModal);
      this._snakeBarSrv.openSnackBarError("La récupération INSi a échoué.");
      return true; // We return true to allow the user to still check the box if they want
    }
    return true;
  }

  public async crossPatientInfos(msg: MessageReleve): Promise<void> {
    console.log(msg);
    const modal = this._modalService.openModal(this._viewContainerRef, ComparePatientInfosComponent);
    modal.instance.initComparePatients({
      nomNaissance: ((msg as any).patientIdentiteRecuperee as InfosPatient).nomNaissance,
      prenomNaissance: ((msg as any).patientIdentiteRecuperee as InfosPatient).prenom,
      dateNaissance: moment(((msg as any).patientIdentiteRecuperee as InfosPatient).dateNaissance, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      sexe: ((msg as any).patientIdentiteRecuperee as InfosPatient).sexe,
      ins: ((msg as any).patientIdentiteRecuperee as InfosPatient).ins,
    }, {
      nomNaissance: msg.patientInfosStatusRecupere.patientNomNaissance,
      prenomNaissance: msg.patientInfosStatusRecupere.patientPrenomNaissance,
      dateNaissance: moment(msg.patientInfosStatusRecupere.patientDateNaissance, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      sexe: msg.patientInfosStatusRecupere.patientSexe,
      ins: msg.patientInfosStatusRecupere.patientIns,
    });
    const modalSub = modal.instance.closeEmitter.subscribe(v => {
      modalSub.unsubscribe();
      modal.destroy();

      if (v) {
        (msg as any).patient = (msg as any).patientIdentiteRecuperee;
      } else {
        (msg as any).patient = undefined;
      }
    });
  }

  public async updatePatientInsFromMessage(msg: MessageReleveForm): Promise<void> {

    if (!msg.isDomaineConfiance) {
      this._modalService.openAlert(this._viewContainerRef, 'Erreur', 'Impossible de mettre à jour le patient : \n\nExpediteur hors du domaine d\'identification du cabinet sans contrat de confiance (adresse de MSS non présente dans un correspondant du cabinet)');
      return;
    }

    if(msg.patient && !msg.manuallyAdded) {
      this._modalService.openAlert(this._viewContainerRef, 'Erreur', 'Impossible de mettre à jour le patient : \n\nLe patient est déjà qualifié');
      return;
    }

    if(msg.patient && msg.manuallyAdded) {
      this._modalService.openAlert(this._viewContainerRef, 'Erreur', 'Impossible de mettre à jour le patient : \n\nPatient selectionné directement dans la base');
      return;
    }

    const _getSexeIndex = (sexe: string | undefined): 1 | 2 | 3 | undefined => {
      switch (sexe) {
        case 'INDETERMINE':
          return 1;
        case 'HOMME':
          return 2;
        case 'FEMME':
          return 3;
        default:
          return undefined;
      }
    };

    const loading = this._modalService.openLoading(this._viewContainerRef);


    // Il manque le cas qualifié :o
    if (msg.patientInfosStatusProvisoire || msg.patientInfosStatusRecupere || msg.patientInfosStatusValide && this._initCpxSession()) {
      let infoStatut:PatientInfosStatusValide | undefined = undefined;
      if (msg.patientInfosStatusProvisoire) {
        infoStatut = msg.patientInfosStatusProvisoire;
      } else if (msg.patientInfosStatusRecupere) {
        infoStatut = msg.patientInfosStatusRecupere;
      } else if (msg.patientInfosStatusValide) {
        infoStatut = msg.patientInfosStatusValide;
      }

      let testIns = undefined;
      try {
        testIns = await this._insSrv.checkInsIdentity(this._viewContainerRef, {
          i_sex: _getSexeIndex(infoStatut.patientSexe),
          s_birthDate: infoStatut.patientDateNaissance,
          s_birthName: infoStatut.patientNomNaissance,
          s_given: infoStatut.patientPrenomNaissance,
          s_ins: infoStatut.patientIns,
          s_key: infoStatut.patientInsKey,
          s_oid: infoStatut.patientOid,
          s_birthPlace: infoStatut.patientCpNaissance,
        });
      } catch (e) {
        console.error(e);
        this._modalService.openAlert(this._viewContainerRef, 'Erreur', 'Impossible de mettre à jour le patient : \n\nUne erreur est survenue lors de la vérification de l\'INS');
      }

      if (testIns) {
        const patientDataAlert = `${infoStatut.patientNomNaissance} ${infoStatut.patientPrenomNaissance} (${moment(msg.patientInfosStatusValide.patientDateNaissance, 'YYYY-MM-DD').format('DD/MM/YYYY')})`;
        // Ouvrir une modal pour demander si l'utilisateur veut mettre à jour l'INS
        const modalConfirm = await this._modalService.openModalConfirmation(
          this._viewContainerRef,
          'INS valide',
          `Les test confirme la validité de l'INS, vous pouvez donc lier l'INS ${infoStatut.patientIns}${infoStatut.patientInsKey} au patient ${patientDataAlert}\n\nVoulez-vous lier cet INS à ce patient ?`
        );

        const modalConfirmSub = modalConfirm.instance.closeEmitter.subscribe(async v => {
          modalConfirmSub.unsubscribe();
          if (v) {
            let updateIdentiteSuccess = false;
            try {
              const patient = await this._patientSrv.findOnePatientFiche(infoStatut.patientId);
              if (patient) {
                const fiche: FichePatient = {
                  id: patient.id,
                  idTitre: patient.idTitre,
                  sexe: infoStatut.patientSexe,
                  nom: patient.nom,
                  prenom: infoStatut.patientPrenomNaissance,
                  nomNaissance: infoStatut.patientNomNaissance,
                  dateNaissance: infoStatut.patientDateNaissance,
                  nomUsage: patient.nomUsage,
                  prenomUsage: patient.prenomUsage,
                  idGroupeSanguin: patient.idGroupeSanguin,
                  idSituationMaritale: patient.idSituationMaritale,
                  villeNaissance: patient.villeNaissance,
                  cpNaissance: patient.cpNaissance,
                  nbEnfant: patient.nbEnfant,
                  nomMt: patient.nomMt,
                  prenomMt: patient.prenomMt,
                  numeroMobile: patient.numeroMobile,
                  professions: patient.professions,
                  adresses: patient.adresses,
                  documentDeValidation: patient.documentDeValidation,
                  identiteAttribut: patient.identiteAttribut,
                  forceIdentityUpdate: patient.forceIdentityUpdate,
                  mssPatientConsentement: patient.mssPatientConsentement,
                  ins: infoStatut.patientIns,
                  insKey: infoStatut.patientInsKey,
                  oid: infoStatut.patientOid,
                  prenomsNaissance: infoStatut.patientPrenomNaissance,
                };
                await this._patientSrv.updatePatientFiche(infoStatut.patientId, fiche);
                updateIdentiteSuccess = true;

                await this._modalService.openAlert(
                  this._viewContainerRef,
                  'Mise à jour réussie',
                  `La mise à jour des informations d'identité du patient ${patientDataAlert} ont bien été mises à jour.`
                );
              }
            } catch (e) {
              await this._modalService.openAlert(
                this._viewContainerRef,
                'Erreur',
                `Une erreur c'est produite lors de la mise à jour de l'identité du patient ${patientDataAlert}.`
              );
            }

            if (updateIdentiteSuccess) {
              // update document (pour ajouter l'ID du patient et ainsi permettre le liaison entre le patient et le document)
              await this._mssSrv.getService().updateCourrierReleve({
                messageId: msg.id,
                patientDateNaissance: undefined,
                patientIns: undefined,
                patientInsKey: undefined,
                patientNomNaissance: undefined,
                patientOid: undefined,
                patientPrenomNaissance: undefined,
                patientSexe: undefined,
                isInsOk: undefined,
                patientId: infoStatut.patientId
              });

              // refresh le tableau des courriers relevés
              await this.ngOnInit();
            }
          }
        });
      } else if (testIns === false) {
        this._modalService.openAlert(
          this._viewContainerRef,
          'Erreur INS',
          'Le test de l\'INS renvoi une erreur,\nil est donc impossible d\'associer le patient à l\'INS de l\'identité présente dans le document.'
        );
      }
    }

    if (loading) {
      loading.destroy();
    }
  }

  private _initCpxSession(): boolean {
    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      const currentProfil = JSON.parse(currentProfilStr);
      this._insSrv.resourceId = currentProfil.id;
      return true;
    } else {
      return false;
    }
  }

  public onMatSortChange(sort: Sort) {

    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      return (a < b ? 1 : -1) * (isAsc ? -1 : 1);
    };

    const getPatientFromMessage = (msg: MessageReleveForm): InfosPatient | undefined => {
      if (msg.patient) {
        return msg.patient;
      } else if (msg.patientIdentiteRecuperee) {
        return msg.patientIdentiteRecuperee;
      } else if (msg.patientIdentiteValidee) {
        return msg.patientIdentiteValidee;
      } else if (msg.patientIdentiteProvisoire) {
        return msg.patientIdentiteProvisoire;
      } else {
        return undefined;
      }
    };

    const setData = (data: Array<MessageReleveForm>): void => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
    };

    const data = JSON.parse(JSON.stringify(this.data)) as Array<MessageReleveForm>;
    if (!sort.active || sort.direction === '') {
      setData(data);
      return;
    }

    const sorted = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'from':
          return compare(a.from, b.from, isAsc);
        case 'to':
          return compare(`${a.to.prenom} ${a.to.nom}`, `${b.to.prenom} ${b.to.nom}`, isAsc);
        case 'documentType':
          return compare(a.cdaMetadata?.type?.displayName, b.cdaMetadata?.type?.displayName, isAsc);
        case 'receivedDate':
          return compare(new Date(a.receivedDate).getTime(), new Date(b.receivedDate).getTime(), isAsc);
        case 'patient':
          const patientA = getPatientFromMessage(a);
          const patientB = getPatientFromMessage(b);
          const patientAStr = patientA ? `${patientA.prenom} ${patientA.nom}` : '';
          const patientBStr = patientB ? `${patientB.prenom} ${patientB.nom}` : '';
          return compare(patientAStr, patientBStr, isAsc);
        default:
          return 0;
      }
    });
    setData(sorted);
  }

  public getReadableDate(isoString: string): string {
    return moment(isoString).format('DD/MM/YYYY HH:mm');
  }

  public getReadableSize(size: number): string {
    return (size / 1024).toFixed(2) + ' Ko';
  }

  public async handleTraiter(e, message: MessageReleveForm): Promise<void> {
    if (message.traiter) {
      message.traiter = false;
    } else {
      if (message.patientIdentiteValidee || message.patientIdentiteProvisoire) {
         // Cas 2: Comparaison visuelle et récupération INSi
         const res = await this.compareAndRecover(message);
         if (!res) {
            // L'utilisateur a annulé la modale
            e.preventDefault();
            return;
         }
      }
      message.traiter = true;
      message.supprimer = false;
    }
  }

  public handleSupprimer(e, message: MessageReleveForm): void {
    if (message.supprimer) {
      message.supprimer = false;
    } else {
      message.supprimer = true;
      message.traiter = false;
      this.deletePatient(message);
    }
  }

  public async lancerTraitement(): Promise<void> {
    const messageATraiter = this.dataSource.data.filter((message) =>
      (
        message.traiter
        && (message.patient || message.patientIdentiteRecuperee || message.patientIdentiteValidee || message.patientIdentiteProvisoire)
      ) || message.supprimer);

    const modal: ComponentRef<ProgressFragment> = this._modalService.openModal(
      this._viewContainerRef,
      ProgressFragment,
      [
        { name: 'header', value: 'Traitement du courrier relevé' },
        { name: 'msg', value: 'Veuillez patienter pendant le traitement...' },
        { name: 'unit', value: 'courrier traité(s)' },
        { name: 'total', value: messageATraiter.length },
        { name: 'errorModeMessage', value: 'Un ou plusieurs courriers n\'ont pas pu être traité. La traitement se poursuis avec les autres courriers.' },
      ]
    );

    for (const message of messageATraiter) {

      try {
        if (message.supprimer) {
          await this._mssSrv.getService().deleteMessageReleve(message.id);
        } else {
          const patientId = message.patient?.id || message.patientIdentiteRecuperee?.id || message.patientIdentiteValidee?.id || message.patientIdentiteProvisoire?.id || undefined;
          if (patientId) {
            if (message.qualifierIdentity && message.patientIdentiteRecuperee) {
               try {
                 const fichePatient = await this._patientSrv.findOnePatientFiche(patientId);
                 if (fichePatient) {
                    fichePatient.identiteStatutLibelle = 'identité qualifiée';
                    fichePatient.identiteStatutId = '95a6081f-5260-44b8-9661-e4795e1cfcaf';
                    fichePatient.documentDeValidation = '026a93be-d90f-4212-a1c0-0dab592e3972'; // ID Carte Nationale d'Identité par défaut
                    
                    const user = this._loginSrv.getCurrentUser();
                    if (!fichePatient.historique) fichePatient.historique = [];
                    fichePatient.historique.push({
                       type: 'modification' as any,
                       date: new Date(),
                       newIdentite: { statut: fichePatient.identiteStatutLibelle },
                       responsable: { id: user ? user.id : 'cabinet', libelle: user ? (user.nom + ' ' + user.prenom) : 'Cabinet (Qualification via MSS)' }
                    });
                    await this._patientSrv.updatePatientFiche(patientId, fichePatient);
                 }
               } catch (err) {
                 console.error("Erreur lors de la qualification du patient", err);
               }
            }
            await this._mssSrv.getService().traiterMessageReleve(message.id, patientId, message.createConsult,message.typeConsult,message.subject);
          }
        }
      } catch (e) {
        this.errorTraitement.set(message, e);
        modal.instance.errorMode = true;
      }


      modal.instance.increment();
    }

    await new Promise<void>((resolve) => setTimeout(() => {
      resolve();
      modal.destroy();
     }, 1000));

    const loadingModal = this._modalService.openLoading(this._viewContainerRef);
    await this.retrieveCourrierAndUpdateTable();
    this._modalService.close(loadingModal);


    // this.dataLength = this.dataSource.data.length;
    this._modalService.close(loadingModal);
  }

  public async downloadDocument(document: Document, message: MessageReleveForm): Promise<void> {
    const displayDocumentInstance = (await this._displayDocumentSrv.displayDocument(
      this._viewContainerRef,
      {
        contentType: document.contentType,
        fileName: document.fileName,
        id: document.id,
        title : 'Piece Jointe',
        data: '',
        date: message.receivedDate,
        dataPrint: ''
      }
      )
    ) as ComponentRef<DisplayDocumentComponent>;
    if(displayDocumentInstance){
      displayDocumentInstance.instance.isNextDocument = false;
      displayDocumentInstance.instance.isPreviousDocument = false;
    }
  }

  public isObjectEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  public getDateFormatted(date: Date): string {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  public onEditComplete(message: any): void {
    if(message.cleanSubject == ""){
      message.cleanSubject = "Message sans sujet";
    }
    message.subject = message.cleanSubject;
  }
}
